// V3 cosmetic title unlocks. Awarded at 5 / 15 / 40 lifetime matches.
// These are display-only; they have no gameplay effect.

export interface UnlockTier {
  matchThreshold: number;
  title: string;
  description: string;
}

export const UNLOCK_TIERS: UnlockTier[] = [
  { matchThreshold: 5, title: 'Veteran', description: 'Played 5 matches' },
  { matchThreshold: 15, title: 'Signal Tactician', description: 'Played 15 matches' },
  { matchThreshold: 40, title: 'Commander', description: 'Played 40 matches' },
];

export function getEarnedTiers(totalMatches: number): UnlockTier[] {
  return UNLOCK_TIERS.filter((t) => totalMatches >= t.matchThreshold);
}

export function getNextTier(totalMatches: number): UnlockTier | null {
  return UNLOCK_TIERS.find((t) => totalMatches < t.matchThreshold) ?? null;
}

/** The highest earned title, or null if no matches yet. */
export function getActiveTitle(totalMatches: number): string | null {
  const earned = getEarnedTiers(totalMatches);
  return earned.length > 0 ? (earned[earned.length - 1]!.title) : null;
}
